export default __webpack_public_path__ + "static/ump-fedbaac4f56881e8f00929ad34230fc0.png";